import React, { useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import postscribe from 'postscribe';
import isHtml from 'is-html';

const CustomScripts = () => {
  const { scriptJs } = useSelector(({ product }) => product);

  const body = useMemo(() => document.querySelector('body'), []);

  const filterRegex = useCallback((regex, script, normalizedScripts) => {
    let noMatch = script;
    let match = '';

    const matches = script.match(regex);
    if (matches) {
      matches.forEach(item => {
        noMatch = noMatch.replace(item, '');
        match += item;
      });
    }

    return [normalizedScripts + match, noMatch];
  }, []);

  const normalizedScript = useMemo(() => {
    let script = scriptJs;
    let normalizedScripts = '';

    if (isHtml(script)) {
      return script;
    }

    if (script) {
      [normalizedScripts, script] = filterRegex(
        new RegExp(/<script(?:.*)>(?:.*)<\/script>/g),
        script,
        normalizedScripts,
      );
    }
    if (script) {
      [normalizedScripts, script] = filterRegex(
        new RegExp(/<(?:.*)>(?:.*)<\/(?:.*)>/g),
        script,
        normalizedScripts,
      );
    }
    if (script) {
      [normalizedScripts, script] = filterRegex(
        new RegExp(/<(?:.*)>/g),
        script,
        normalizedScripts,
      );
    }
    if (script) normalizedScripts += `<script>${script}</script>`;

    if (isHtml(normalizedScripts)) {
      return normalizedScripts;
    }

    return '';
  }, [filterRegex, scriptJs]);

  useEffect(() => {
    postscribe(body, normalizedScript);
  }, [normalizedScript, body]);

  return <></>;
};

export default CustomScripts;
